
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelConeDown as ObiBuoyBarrelConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-cone-down.js';
 
 
 

 
 export const ObiBuoyBarrelConeDown = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-cone-down',
   elementClass: ObiBuoyBarrelConeDownElement,
   events: {
     
   }
  });
 
 